import { AppsLink, AppsRoutes } from '@wellesley/router'
import { RouteProps } from '@wellesley/router/types'
import { Params } from '@wellesley/router/getParams'
import { MouseEvent, PropsWithChildren } from 'react'
import { useParams } from 'react-router-dom'

type TargetBlank = '_blank'

type GroupAppsLinkProps<T = RouteProps, P extends Params = Params> = {
  target?: TargetBlank
  to: AppsRoutes | ''
  props?: T
  queryParams?: P
  className?: string
  disabled?: boolean
  onClick?: (e: MouseEvent<HTMLAnchorElement>) => void
  groupName?: string
}

export const GroupAppsLink = <
  T extends RouteProps = RouteProps,
  P extends Params = Params,
>(
  props: PropsWithChildren<GroupAppsLinkProps<T, P>>,
) => {
  const { groupName, ...restProps } = props || {}

  const { groupname = '' } = useParams()
  const groupnameParam = groupName || groupname

  return (
    <AppsLink
      {...restProps}
      props={{ ...props.props, groupname: groupnameParam }}
    />
  )
}
